import { Loader2 } from 'lucide-react';
import React from 'react';

const Loading: React.FC = () => {
    return (
        <div className="flex flex-col items-center justify-center">
            <Loader2 className="text-primary animate-spin mb-4" size={64} />
            <p className="text-primary font-roboto text-md font-bold">
                Loading Data...
            </p>
        </div>
    )
}

export default Loading;

